import React, { useEffect, useState } from "react";
import { supabase } from "../lib/supabaseClient.ts";
import { v4 as uuidv4 } from "uuid";

export default function CategoryManager() {
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [loading, setLoading] = useState(true);

  const [newSubcatName, setNewSubcatName] = useState("");
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const [editItem, setEditItem] = useState(null);
  const [editInput, setEditInput] = useState("");

  const [activeAddSubForm, setActiveAddSubForm] = useState(null);
const [subcatImages, setSubcatImages] = useState({}); // local preview URLs
const [uploading, setUploading] = useState(false);

// Function to handle image upload
const handleSubcatImageUpload = async (e, subcatId) => {
  const file = e.target.files[0];
  if (!file) return;

  const fileExt = file.name.split('.').pop();
  const fileName = `${uuidv4()}.${fileExt}`;
  const filePath = `subs/${fileName}`;

  setUploading(true);

  const { error: uploadError } = await supabase.storage
    .from("animalia")
    .upload(filePath, file, { cacheControl: "3600", upsert: true });

  if (uploadError) {
    alert("Erreur lors de l'upload : " + uploadError.message);
    setUploading(false);
    return;
  }

  const { data: publicUrlData } = supabase.storage
    .from("animalia")
    .getPublicUrl(filePath);

  const { error: updateError } = await supabase
    .from("subcategories")
    .update({ image: publicUrlData.publicUrl })
    .eq("id", subcatId)
  .order("order", { ascending: true });


  if (updateError) alert("Erreur lors de la mise à jour de la sous-catégorie");
  else {
    setSubcatImages(prev => ({ ...prev, [subcatId]: publicUrlData.publicUrl }));
    fetchData();
  }

  setUploading(false);
};
  useEffect(() => {
    fetchData();
  }, []);

  async function fetchData() {
    setLoading(true);
    const { data: cats } = await supabase.from("categories").select("*").order("name");
    const { data: subcats } = await supabase.from("subcategories").select("*").order("name");

    const uniqueCats = Array.from(new Map((cats || []).map(c => [c.name.toLowerCase(), c])).values());
    const seenSub = new Set();
    const uniqueSubs = (subcats || []).filter(s => {
      const key = s.category_id + "::" + s.name.toLowerCase();
      if (seenSub.has(key)) return false;
      seenSub.add(key);
      return true;
    });

    setCategories(uniqueCats);
    setSubcategories(uniqueSubs);
    setLoading(false);
  }

  const getSubcategoriesForCategory = (categoryId) =>
    subcategories.filter((s) => s.category_id === categoryId);

  async function addSubcategory(catId) {
  if (!newSubcatName.trim()) return alert("Enter subcategory name");

  // Check for duplicates
  if (
    subcategories.some(
      (s) =>
        s.category_id === catId &&
        s.name.toLowerCase() === newSubcatName.trim().toLowerCase()
    )
  ) {
    return alert("Subcategory already exists");
  }

  // Get current max order for this category
  const { data: existingSubs } = await supabase
    .from("subcategories")
    .select("order")
    .eq("category_id", catId);

  const nextOrder =
    existingSubs && existingSubs.length > 0
      ? Math.max(...existingSubs.map((s) => s.order)) + 1
      : 0;

  // Insert with order
  const { error } = await supabase
    .from("subcategories")
    .insert({
      name: newSubcatName.trim(),
      category_id: catId,
      order: nextOrder,
    });

  if (error) alert("Error adding subcategory");
  else {
    setNewSubcatName("");
    setActiveAddSubForm(null);
    fetchData();
  }
}


  async function handleUpdate() {
    if (!editInput.trim()) return alert("Enter a name");

    const table = editItem.type === "category" ? "categories" : "subcategories";

    const { error } = await supabase
      .from(table)
      .update({ name: editInput.trim() })
      .eq("id", editItem.id);

    if (error) {
      alert("Error updating");
    } else {
      setEditItem(null);
      setEditInput("");
      fetchData();
    }
  }

  async function deleteItem(type, id) {
    const confirm = window.confirm("Supprimer cet élément ?");
    if (!confirm) return;
    const table = type === "category" ? "categories" : "subcategories";
    const { error } = await supabase.from(table).delete().eq("id", id);
    if (error) alert("Erreur lors de la suppression");
    fetchData();
  }
async function moveSubcat(subcatId, direction) {
  const subcat = subcategories.find(s => s.id === subcatId);
  if (!subcat) return;

  const siblings = subcategories
    .filter(s => s.category_id === subcat.category_id)
    .sort((a,b) => a.order - b.order);

  const index = siblings.findIndex(s => s.id === subcatId);
  const newIndex = index + direction;

  if (newIndex < 0 || newIndex >= siblings.length) return; // can't move further

  const swapWith = siblings[newIndex];

  // Swap orders
  await supabase.from("subcategories")
    .update({ order: swapWith.order })
    .eq("id", subcat.id);

  await supabase.from("subcategories")
    .update({ order: subcat.order })
    .eq("id", swapWith.id);

  fetchData();
}

  if (loading) return <div style={{ textAlign: "center", marginTop: 80 }}>Loading...</div>;
return (
  <div style={{ margin: "80px 24px" }}>
    {/* Category Filter */}
    {/* <div style={{ marginBottom: 24, textAlign: "center" }}>
      <label htmlFor="categoryFilter" style={{ marginRight: 8, fontWeight: "bold" }}>
        Filtrer par catégorie:
      </label>
      <select
        id="categoryFilter"
        value={selectedCategoryId || ""}
        onChange={(e) => setSelectedCategoryId(Number(e.target.value) || null)}
        style={{
          padding: "6px 12px",
          borderRadius: 6,
          border: "1px solid #ccc",
          fontSize: 15,
        }}
      >
        <option value="">Toutes</option>
        {categories.map((cat) => (
          <option key={cat.id} value={cat.id}>
            {cat.name}
          </option>
        ))}
      </select>
    </div> */}

    {/* Categories Grid */}
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(400px, 1fr))", // 2 cards per row
        gap: 24,
      }}
    >
      {categories
        .filter((cat) => !selectedCategoryId || cat.id === selectedCategoryId)
        .map((cat) => (
          <div
            key={cat.id}
            style={{
              backgroundColor: "#fff",
              boxShadow: "0 4px 10px rgba(0,0,0,0.06)",
              borderRadius: 10,
              padding: "1rem 1.25rem",
              display: "flex",
              flexDirection: "column",
            }}
          >
            {/* Category header */}
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              {editItem?.type === "category" && editItem.id === cat.id ? (
                <input
                  value={editInput}
                  onChange={(e) => setEditInput(e.target.value)}
                  style={{ ...inputStyle, flex: 1 }}
                />
              ) : (
                <h3 style={{ margin: 0 }}>{cat.name}</h3>
              )}
              <div style={{ display: "flex", gap: 6 }}>
                {editItem?.type === "category" && editItem.id === cat.id ? (
                  <>
                    <button onClick={handleUpdate} style={smallBtnStyle}>✅</button>
                    <button onClick={() => setEditItem(null)} style={smallBtnStyle}>❌</button>
                  </>
                ) : (
                  <>
                    <button
                      onClick={() => {
                        setEditItem({ type: "category", id: cat.id });
                        setEditInput(cat.name);
                      }}
                      style={smallBtnStyle}
                    >
                      ✏️
                    </button>
                    <button
                      onClick={() => deleteItem("category", cat.id)}
                      style={smallBtnStyle}
                    >
                      🗑️
                    </button>
                  </>
                )}
              </div>
            </div>

            {/* Subcategories */}
      <ul style={{ listStyle: "none", paddingLeft: 0, marginTop: 12 }}>
  {getSubcategoriesForCategory(cat.id).map((subcat) => (
    <li
      key={subcat.id}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 12,
        marginBottom: 8,
        fontSize: 15,
      }}
    >
      {/* Order input */}
      <input
        type="number"
        value={subcat.order}
        min={0}
        style={{
          width: 50,
          padding: "4px 6px",
          borderRadius: 4,
          border: "1px solid #ccc",
          textAlign: "center",
          flexShrink: 0,
        }}
        onChange={async (e) => {
          const newOrder = parseInt(e.target.value, 10);
          if (isNaN(newOrder)) return;

          const { error } = await supabase
            .from("subcategories")
            .update({ order: newOrder })
            .eq("id", subcat.id);

          if (error) alert("Erreur lors de la mise à jour de l'ordre");
          else fetchData();
        }}
      />

      {/* Image + Name */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
          flex: 1, // take available space
        }}
      >
        {subcat.image && (
          <img
            src={subcatImages[subcat.id] || subcat.image}
            alt={subcat.name}
            style={{ width: 40, height: 40, objectFit: "cover", borderRadius: 6 }}
          />
        )}
        <span>{subcat.name}</span>
      </div>

      {/* Actions */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 6,
          flexShrink: 0,
        }}
      >
        {/* Image Upload */}
        <label
          htmlFor={`file-upload-${subcat.id}`}
          style={{
            display: "inline-block",
            padding: "6px 12px",
            backgroundColor: "#c71585",
            color: "#fff",
            borderRadius: 6,
            cursor: uploading ? "not-allowed" : "pointer",
            fontSize: 13,
            fontWeight: "bold",
            border: "none",
          }}
        >
          {uploading ? "Uploading..." : "Upload Image"}
        </label>
        <input
          id={`file-upload-${subcat.id}`}
          type="file"
          accept="image/*"
          onChange={(e) => handleSubcatImageUpload(e, subcat.id)}
          style={{ display: "none" }}
          disabled={uploading}
        />

        {/* Edit / Delete */}
        {editItem?.type === "subcategory" && editItem.id === subcat.id ? (
          <>
            <input
              value={editInput}
              onChange={(e) => setEditInput(e.target.value)}
              style={{ ...inputStyle, flexShrink: 0, width: 120 }}
            />
            <button onClick={handleUpdate} style={smallBtnStyle}>✅</button>
            <button onClick={() => setEditItem(null)} style={smallBtnStyle}>❌</button>
          </>
        ) : (
          <>
            <button
              onClick={() => {
                setEditItem({
                  type: "subcategory",
                  id: subcat.id,
                  category_id: subcat.category_id,
                });
                setEditInput(subcat.name);
              }}
              style={smallBtnStyle}
            >
              ✏️
            </button>
            <button
              onClick={() => deleteItem("subcategory", subcat.id)}
              style={smallBtnStyle}
            >
              🗑️
            </button>
          </>
        )}
      </div>
    </li>
  ))}

  {getSubcategoriesForCategory(cat.id).length === 0 && (
    <li style={{ fontStyle: "italic", color: "#777", fontSize: 14 }}>
      Aucune sous-catégorie
    </li>
  )}
</ul>

            {/* Add subcategory input */}
            {activeAddSubForm === cat.id ? (
              <div style={{ marginTop: 10 }}>
                <input
                  value={newSubcatName}
                  onChange={(e) => setNewSubcatName(e.target.value)}
                  placeholder="Nom sous-catégorie"
                  style={{ ...inputStyle, width: "100%", marginBottom: 6 }}
                />
                <div style={{ display: "flex", gap: 8 }}>
                  <button onClick={() => addSubcategory(cat.id)} style={primaryBtnStyle}>
                    Ajouter
                  </button>
                  <button onClick={() => setActiveAddSubForm(null)} style={cancelBtnStyle}>
                    Annuler
                  </button>
                </div>
              </div>
            ) : (
              <button
                onClick={() => {
                  setActiveAddSubForm(cat.id);
                  setNewSubcatName("");
                }}
                style={{
                  marginTop: 12,
                  padding: "6px 12px",
                  fontSize: 14,
                  borderRadius: 6,
                  border: "1px solid #aaa",
                  backgroundColor: "#f5f5f5",
                  cursor: "pointer",
                  color:"gray"
                }}
              >
                ➕ Ajouter une sous-catégorie
              </button>
            )}
          </div>
        ))}
    </div>
  </div>
);

}

// Reusable styles
const inputStyle = {
  padding: "8px 12px",
  fontSize: 15,
  borderRadius: 6,
  border: "1.5px solid #ddd",
  outline: "none",
};

const primaryBtnStyle = {
  padding: "6px 12px",
  borderRadius: 6,
  backgroundColor: "gray",
  color: "#fff",
  fontWeight: "bold",
  border: "none",
  cursor: "pointer",
};

const cancelBtnStyle = {
  padding: "6px 12px",
  borderRadius: 6,
  backgroundColor: "#eee",
  color: "#333",
  fontWeight: "bold",
  border: "1px solid #ccc",
  cursor: "pointer",
};

const smallBtnStyle = {
  padding: "4px 6px",
  borderRadius: 4,
  backgroundColor: "#888",
  color: "#fff",
  fontWeight: "bold",
  fontSize: 13,
  border: "none",
  cursor: "pointer",
};
